const getters = {
  userRole: state => state.userData.role || null,
  isAdmin: state => state.userData.role && state.userData.role === 'admin',
  isB2bUser: state => state.userData.role && state.userData.role === 'b2b',
  paymentCurrency: state =>
    state.fiatList.find(e => e.key === state.paymentCurrencyKey),
  isLogin: state => state.token,
  isUserAgree: state => state.userData.termsAccepted || null,
  isAgeConfirmed: state => state.userData.ageConfirmed === true,
  getOnboardingParams: state => state.userData.onboarding || {},
  getUserBalance: state => state.userData.balance,
}

export default getters
